

export class Preference {
    confirm_delete: boolean;
    sort_by_creation_date_on: boolean;
    hide_completed_subtask_on: boolean;
    reminder_on: boolean;
    assigned_to_me_on: boolean;
    important_on: boolean;
    priority_on: boolean;
    planned_on: boolean;
    auto_hide_empty_list_on: boolean;

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/preference.model.ts